import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCustomerAuth } from '../context/CustomerAuthContext';

export default function SignupPage() {
  const { signup } = useCustomerAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const set = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signup(form);
      navigate('/account/orders', { replace: true });
    } catch (err) {
      setError(err.message || 'Signup failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="section">
        <div className="container" style={{ maxWidth: 420 }}>
          <div className="masthead">
            <span className="eyebrow">Account</span>
            <h1>Create your account</h1>
            <p>Track orders, get quotes, and reorder faster.</p>
          </div>

          {error && (
            <div style={{ background: '#fef2f2', color: '#ef4444', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '13px' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{ ...fieldStyle, flex: 1 }}>
                First name
                <input type="text" value={form.firstName} onChange={set('firstName')} required style={inputStyle} />
              </label>
              <label style={{ ...fieldStyle, flex: 1 }}>
                Last name
                <input type="text" value={form.lastName} onChange={set('lastName')} required style={inputStyle} />
              </label>
            </div>
            <label style={fieldStyle}>
              Email
              <input type="email" value={form.email} onChange={set('email')} required style={inputStyle} />
            </label>
            <label style={fieldStyle}>
              Phone (optional)
              <input type="tel" value={form.phone} onChange={set('phone')} style={inputStyle} />
            </label>
            <label style={fieldStyle}>
              Password
              <input type="password" value={form.password} onChange={set('password')} required minLength={8} style={inputStyle} />
            </label>
            <button type="submit" disabled={submitting} className="btn btn-primary" style={{ width: '100%', marginTop: '8px' }}>
              {submitting ? 'Creating account…' : 'Create account'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '20px', color: 'var(--text-light)', fontSize: '14px' }}>
            Already have an account? <Link to="/login" style={{ color: 'var(--primary-color)', fontWeight: 600 }}>Log in</Link>
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}

const fieldStyle = { display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px', fontWeight: 600, color: '#444', marginBottom: '16px' };
const inputStyle = { padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', fontFamily: 'inherit', width: '100%' };
